// extracted by mini-css-extract-plugin
module.exports = {"page":"Visit_page__3SYB7","button":"Visit_button__3M58F","meetings":"Visit_meetings__1OKQM","title":"Visit_title__2vx2h","notify":"Visit_notify__2hjyG"};